import { css } from 'styled-components'

export const properties = css`
  @property --appBgStart {
    syntax: '<color>';
    inherits: false;
    initial-value: ${(props) => props.theme.colors.app.background.start};
  }
  @property --appBgEnd {
    syntax: '<color>';
    inherits: false;
    initial-value: ${(props) => props.theme.colors.app.background.end};
  }
  @property --dialogPopupBgStart {
    syntax: '<color>';
    inherits: false;
    initial-value: ${(props) =>
      props.theme.colors.dialogPopup.background.start};
  }
  @property --dialogPopupBgEnd {
    syntax: '<color>';
    inherits: false;
    initial-value: ${(props) => props.theme.colors.dialogPopup.background.end};
  }
`
